export const defaultDetectionPostProcessor = `

var selectedImage;

function highlightRect(id) {
    document.getElementById(id + "_rect").style.borderColor = "var(--primary3)";
    document.getElementById(id + "_rect_label").style.backgroundColor = "var(--primary3)";
    document.getElementById(id + "_rect_label").style.color = "white";
    document.getElementById(id + "_data_label").style.fontWeight = "400";
}

function restoreRect(id) {
    document.getElementById(id + "_rect").style.borderColor = "yellow";
    document.getElementById(id + "_rect_label").style.backgroundColor = "yellow";
    document.getElementById(id + "_rect_label").style.color = "black";
    document.getElementById(id + "_data_label").style.fontWeight = "normal";
}

function drawBoundingBoxRect(container, id, x, y, w, h, progress, text = "") {
    const topContainer = document.createElement("div");
    const rect = document.createElement("div");
    rect.id = id + "_rect";
    rect.style.position = "absolute";
    rect.style.top = y + "px";
    rect.style.left = x + "px";
    rect.style.width = w + "px";
    rect.style.height = h + "px";
    rect.style.border = "1px solid yellow";
    rect.style.opacity = "0.75";

    const label = document.createElement("div");
    label.id = id + "_rect_label";
    label.style.position = "absolute";
    label.style.backgroundColor = "yellow";
    label.style.color = "black";
    label.style.fontSize = "0.75rem";
    label.style.padding = "2px";
    label.style.opacity = "0.75";
    label.style.textTransform = "capitalize";

    // Format label text
    label.innerText = text + " (" + (progress * 100).toFixed(0) + "%)";

    rect.addEventListener("mouseover", () => highlightRect(id));
    rect.addEventListener("mouseout", () => restoreRect(id));
     // Attach the label to the bounding box
    topContainer.appendChild(label);
    topContainer.appendChild(rect);
    container.appendChild(topContainer);
     // Calculate label position to keep it within the image bounds
    const labelWidth = label.offsetWidth;
    const labelHeight = label.offsetHeight;
    const imageWidth = container.clientWidth;
    const imageHeight = container.clientHeight;

    let labelX = x; // Default X position
    let labelY = y - (labelHeight || 18); // Position label above the rect by default

    // Adjust if label exceeds right boundary
    if (x + labelWidth > imageWidth) {
      labelX = imageWidth - labelWidth - 5;
    }

    // Adjust if label exceeds bottom boundary
    if (y + h + (labelHeight || 20) > imageHeight) {
      labelY = y - labelHeight; // Position it above if close to bottom
    }

    if (labelY < 0) {
      labelY = 0;
    }

    // Apply final label position
    label.style.minWidth = (rect.clientWidth + 2) + "px";
    label.style.left = labelX + "px";
    label.style.top = labelY + "px";
}

function displayStatistics(container, id, dataRecord) {
    const entry = document.createElement("div");
    entry.style = "display: flex;padding:5px 0;align-items:center";

    const entryLabel = document.createElement("div");
    entryLabel.id = id + "_data_label";
    entryLabel.style = "width:100px;text-transform:capitalize;";
    entryLabel.innerText = dataRecord.label;
    entry.appendChild(entryLabel);

    const entryBar = document.createElement("div");
    entryBar.style = "height:10px;width:50px;background-color:var(--greyscale2);margin:0 5px;";
    const slider = document.createElement("div");
    slider.style = "height:10px;width:" + Math.round(50 * dataRecord.progress) + "px;background-color:var(--primary3);";
    entryBar.appendChild(slider);
    entry.appendChild(entryBar);

    const entryPercent = document.createElement("div");
    entryPercent.style = "width:50px;";
    entryPercent.innerText = Math.round(dataRecord.progress * 1000) / 10 + "%";
    entry.appendChild(entryPercent);

    entry.addEventListener("mouseover", (event) => { highlightRect(id); });
    entry.addEventListener("mouseout", (event) => { restoreRect(id); });

    container.appendChild(entry);
}

export function setSelectedImage(imageElement, filename, data) {
    imageElement.style.borderColor = "var(--primary1)";
    selectedImage = imageElement;

    const preview = document.getElementById("inference-results-preview");
    preview.innerHTML = "";

    const title = document.createElement("div");
    title.style = "font-weight:400; width: 100%; margin:10px 5px 0 5px;";
    title.innerText = filename;
    preview.appendChild(title);

    const imgWrapper = document.createElement("div");
    imgWrapper.style = "overflow: hidden; position: relative; width: auto; height: 500px; margin:10px 5px;";
    const image = document.createElement("img");
    image.style = "width: auto; height: 500px;";
    image.src = imageElement.src;
    image.onload = function () {
        let w = image.clientWidth;
        let h = image.clientHeight;

        for (let i = 0; i < data.length; i++) {
            if (data[i].bbox && data[i].label) {
                const x1 = data[i].bbox[0] * w;
                const y1 = data[i].bbox[1] * h;
                const x2 = data[i].bbox[2] * w;
                const y2 = data[i].bbox[3] * h;
                drawBoundingBoxRect(imgWrapper, "id_" + i, x1, y1, x2, y2, data[i].progress, data[i].label);
                displayStatistics(dataViewer, "id_" + i, data[i]);
            }
        }
    };

    imgWrapper.appendChild(image);
    preview.appendChild(imgWrapper);

    const dataViewer = document.createElement("div");
    dataViewer.style = "flex: 1; margin:10px 5px; padding:0 5px 0 10px;";
    preview.appendChild(dataViewer);
}

export function postprocessImage(index, imagePath, modelOutputJson, annotations, file) {
    if (!file) {
        return;
    }

    const sidebar = document.getElementById("inference-results-sidebar");

    if (typeof modelOutputJson === "string") {
        modelOutputJson = JSON.parse(modelOutputJson);
    }

    const card = document.createElement("div");
    card.style = "display: flex;flex-direction: column;width:140px;";
    sidebar.appendChild(card);

    const image = document.createElement("img");
    image.src = URL.createObjectURL(file);
    image.style = "display:block;width: 125px; height: 125px; margin-top:10px;margin-left:5px;border:2px solid white";
    if (index === 0) {
        image.onload = function () {setSelectedImage(image, file.name, modelOutputJson);};
    }
    card.onclick = function() {setSelectedImage(image, file.name, modelOutputJson);};
    card.appendChild(image);

    const fileNameNode = document.createElement("div");
    fileNameNode.style = "width: 125px; margin-left:5px; white-space: nowrap; overflow:hidden";
    fileNameNode.innerText = file.name;
    card.appendChild(fileNameNode);
}

export function postProcess(rawInferenceResults, annotations, files) {
    if (!rawInferenceResults) {
        return;
    }
    rawInferenceResults =
        typeof rawInferenceResults === "string"
            ? JSON.parse(rawInferenceResults)
            : rawInferenceResults;

    const filesMap = files.reduce(
        (map, file) => ({ ...map, [file.name]: file }),
        {}
    );

    const inferenceResultsMap = rawInferenceResults.reduce(
        (map, inferenceResult)=> ({ ...map, [inferenceResult.imagePath]: inferenceResult}),
        {}
    );

    const container = document.getElementById("inference-results-element");
    container.style = "display: flex; height: 100%; overflow: hidden;";
    container.innerHTML = "";

    const sidebar = document.createElement("div");
    sidebar.id = "inference-results-sidebar";
    sidebar.style = \`font-size: 12px; font-family: Proxima Nova,Arial,Helvetica,sans-serif;color: #626262;
                    align-content: flex-start;flex-direction: row;display: flex;flex-wrap: wrap;max-width: 320px;min-width:150px;
                    overflow-y: auto;border: 1px solid var(--greyscale3);margin-bottom:15px;max-height:calc(100vh - 280px);\`;
    container.appendChild(sidebar);

    const preview = document.createElement("div");
    preview.id = "inference-results-preview";
    preview.style = \`font-size: 14px; font-family: Proxima Nova,Arial,Helvetica,sans-serif;color: #626262;
                    display: flex;flex-grow: 1;flex-wrap: wrap;overflow-y: auto;
                    align-content: flex-start;border: 1px solid var(--greyscale3);margin-left: 14px;margin-bottom:15px;\`;
    container.appendChild(preview);

    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileName = file.name;
        const item = inferenceResultsMap[fileName];
        const output = item["modelOutputJson"];
        postprocessImage(i, fileName, output, annotations, filesMap[fileName]);
    }
}

export function readAnnotations(annotationsOutput) {
    // Add code that makes additional manipulations over the annotations if needed. This function calls each time the
    // inference page is rendered.
}

`;
